import axiosInstance from "../helpers/axiosInstance";

export const usersList = (data = {}) => {
  return axiosInstance.get("/Admin/userList", { params: data });
};

export const getUser = (id) => {
  return axiosInstance.get("/Admin/user", { params: { id } });
};

export const getUserUuid = (uuid, id) => {
  return axiosInstance.get("/Admin/user", { params: { uuid, id: id } });
};

export const addUser = (data) => {
  return axiosInstance.post("/Admin/user", data);
};

export const dataFreezeUser = (userId) => {
  return axiosInstance.post(
    "/Admin/freezeUser",
    { userId: Number(userId) },
    {
      headers: {
        consumer: "apidoc",
        "Content-Type": "application/json",
      },
    }
  );
};

export const updateUser = (data) => {
  return axiosInstance.post("/Admin/user", data);
};

export const deleteUser = (id) => {
  return axiosInstance.delete("/Admin/user", { params: { id } });
};

export const unSuspendUser = (userId) => {
  return axiosInstance.post("/Admin/unsuspendUser", { userId, uuid: "" });
};

const UserService = {
  usersList,
  getUser,
  addUser,
  updateUser,
  deleteUser,
  getUserUuid,
  unSuspendUser,
  dataFreezeUser
};

export default UserService;
